








import { computed, PropType } from 'vue';
import { MediaModel } from '../../models/media.model';
import AulaImg from '../../components/AulaImg.vue';
import Icon from '../../components/Icon.vue';
import { iconClassEnum } from '../../enums/iconClassEnum';
import IconContainer from '../../components/IconContainer.vue';

export default {
  components: { IconContainer, AulaImg, Icon },
  props: {
    media: { type: Object as PropType<MediaModel>, required: true },
    large: { type: Boolean, default: false },
  },
  setup(props) {
    const url = computed(() => {
      if (props.large) {
        return props.media.largeThumbnailUrl;
      }
      return props.media.smallThumbnailUrl;
    });

    return {
      url,
      iconClassEnum,
    };
  },
};
